 
 import axios from "axios";
import CreateHttpService from "../../helpers/HttpService";
import { baseUrl } from "../../shared/baseUrl";
 
 
 
 // getalljobs
const getalljobs = async ( ) => {  
		  const HttpService = CreateHttpService(); 
	const { data }: any = await HttpService.get(`/api/v1/job`)  
  return data
}
 
 // getalljobs by ID
const getalljobsbyID = async ( id: any) => { 
 
	  const HttpService = CreateHttpService(); 
  // const { data }: any = await HttpService.get( `/api/v1/job/${id}`)  
  const { data }: any = await axios.get(baseUrl + `/api/v1/job/${id}`)  
  return data
}
 
// Creact job
const createjob = async (data: any) => {  
 
  const value = {
  	"employmentType": data.employmentType,
		"experienceLevel": data.experienceLevel,
		"education": data.education,
		"jobFunction": data.jobFunction,
		"jobRole": data.jobRole,
		"jobProfile": data.jobProfile,
		"team": data.team,
		"remote": data.remote,
		"jobDescription":data.jobDescription,
		"qualifications": data.qualifications,
		"mustHaveSkills": data.mustHaveSkills,
		"goodHaveSkills": data.goodHaveSkills,
		"summary":data.summary,
		"profileInfo": data.profileInfo,
		"educationDetails": data.educationDetails,
		"workExperience": data.workExperience,
		"additionalDetails": data.additionalDetails,
		"userId": data.userId,
		"email": data.email,
		"location": data.location,
		"currentSalary": data.currentSalary,
		"noticePeriod": data.noticePeriod,
		"totalWorkExperience": data.totalWorkExperience,
		"resume": data.resume,
		"hiringManager": data.hiringManager,
		"recruiterTagged": data.recruiterTagged,
		"numberOfOpenings": data.numberOfOpenings,
		"openingDate": data.openingDate,
		"expiryDate": data.expiryDate,
		"makeJobPrivate": data.makeJobPrivate,
		"firstname": data.firstname,
		"lastname": data.lastname,
		"linkedinUrl": data.linkedinUrl,
		"Phone": data.Phone,
		"expectedSalary": data.expectedSalary,
		"relevantWorkExperience": data.relevantWorkExperience,
    "reasonForJobChange": data.reasonForJobChange,
     "jobLocation": data.jobLocation,
    "workplaceType": data.workplaceType
  }

   
  
  const HttpService = CreateHttpService(); 
  const response = await HttpService.post( `/api/v1/job`,value) 
  
  
  return response
}

 
 
const jobService = { 
  getalljobs, 
  getalljobsbyID,
  createjob
}

export default jobService
